import React, { Component } from "react";
import StepWizard from 'react-step-wizard';
//// componentes reutilizables
import Titulo from "../../generico/TituloPagina";
import { splitImporte } from '../../generico/utils/FormatoInput'

import Paso1 from "./TarjetaPaso1";
import Paso2 from "./TarjetaPaso2";
import Paso3 from "./TarjetaPaso3";
import Paso4 from "./TarjetaPaso4";


export default class PagoTarjeta extends Component {

  constructor(props) {
    super(props);
    this.refPaso1 = React.createRef();
    this.refPaso2 = React.createRef();
    this.refPaso3 = React.createRef();
    this.refPaso4 = React.createRef();
    this.state = {
      rptPaso1: undefined,

      rptPaso1TCTipo: undefined,
      rptPaso1TCDeuda: undefined,
      rptPaso1TCSaldoNormal: undefined,
      rptPaso1TCSaldoPlan: undefined,
      rptPaso1TCDiasMora: undefined,
      rptPaso1TCSaldoMora: undefined,
      rptPaso1TCLinea: undefined,
      rptPaso2Cuenta: undefined,
      rptPaso2CuentaDet: undefined,
      rptPaso2Importe: undefined,
      rptPaso2TC: undefined,
      rptPaso2Moneda: undefined,

    };
  }

  rptPaso1 = (id, tarjeta, tipo, deuda, saldoNormal, saldoPlan, diasMora, saldoMora, linea,moneda) => {
    this.setState({ 
      rptPaso1: id, 
      rptPaso1TC: tarjeta, 
      rptPaso1TCTipo: tipo, 
      rptPaso1TCDeuda: deuda, 
      rptPaso1TCSaldoNormal: saldoNormal,
      rptPaso1TCSaldoPlan: saldoPlan,
      rptPaso1TCDiasMora: diasMora,
      rptPaso1TCSaldoMora: saldoMora,
      rptPaso1TCLinea: linea,
      rptPaso1Moneda: moneda
    }, this.enableNextPaso1);
  }

  enableNextPaso1() {
    this.refPaso1.current.checkGrilla();
  }
  componentDidMount() {
    var resumen = sessionStorage.getItem("resumen")
   
    if (resumen === null)
      console.log("NINGUNO")
    else {
      var nro = resumen;
      //##### datos de tarjeta ######//
      var identificador = nro.substring(0, 4) + "****" + nro.substring(nro.length - 4, nro.length)
      var tipo = sessionStorage.getItem("tipo")
      var deuda = sessionStorage.getItem("deuda")
      var obj = JSON.parse(sessionStorage.getItem("datosTarjeta"))
      var saldoPlan=obj.saldoPlan + " GS"
      var saldoNormal=obj.saldoNormal + " GS"
      var saldoMora=obj.saldoMora + " GS"
      var diasMora=obj.diasMora
      var linea=obj.linea + " GS"
      var moneda=obj.moneda
      this.setState({ 
        rptPaso1: resumen, 
        rptPaso1TC: identificador, 
        rptPaso1TCTipo: tipo, 
        rptPaso1TCDeuda: deuda,
        rptPaso1TCSaldoNormal: saldoNormal,
        rptPaso1TCSaldoPlan: saldoPlan,
        rptPaso1TCDiasMora: diasMora,
        rptPaso1TCSaldoMora: saldoMora,
        rptPaso1TCLinea: linea,
        rptPaso1Moneda:moneda
      })

      sessionStorage.removeItem("resumen")
      sessionStorage.removeItem("tipo")
      sessionStorage.removeItem("deuda")
      this.refPaso2.current.getDetalleTarjeta(resumen)
      this.refPaso1.current.nextStep.click()
    }

  }

  paso1Next = () => {

    this.refPaso2.current.getDetalleTarjeta(this.state.rptPaso1)
    this.refPaso1.current.nextStep.click()
  };
  
  rptPaso2Cuenta = (respuesta) => {

    this.setState({ rptPaso2Cuenta: respuesta.value, rptPaso2CuentaDet: respuesta.label });

  }

  rptPaso2Importe = (respuesta) => {

    this.setState({ rptPaso2Importe: respuesta });

  }
  rptPaso2Moneda = (respuesta) => {

    this.setState({ rptPaso2Moneda: respuesta });

  }

  paso2Next = () => {


    this.refPaso2.current.nextStep.click()
  };

  paso3Next = () => {

 this.refPaso4.current.confirmarPago(this.state.rptPaso1, this.state.rptPaso2Cuenta, splitImporte(this.state.rptPaso2Importe));
   var cuentaDebito = this.state.rptPaso2CuentaDet.split("Saldo");
   cuentaDebito = cuentaDebito[0].trim();
   this.setState({rptPaso2CuentaDet :cuentaDebito});
   this.refPaso3.current.nextStep.click()
  };

  render() {

    return (
      <div className="content-wrapper">
        <Titulo texto="Pago de Tarjeta de Crédito" />
        <section className="content">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <StepWizard transitions='none'>
                      <Paso1 ref={this.refPaso1} rptPaso1={this.rptPaso1.bind(this)}  rptPaso2Importe={this.rptPaso2Importe.bind(this)}  paso1Next={this.paso1Next.bind(this)} />
                      <Paso2 ref={this.refPaso2} rptPaso2Cuenta={this.rptPaso2Cuenta.bind(this)}     rptPaso2Moneda={this.rptPaso2Moneda.bind(this)}  rptPaso2Importe={this.rptPaso2Importe.bind(this)} paso2Next={this.paso2Next.bind(this)} 
                      tarjeta={this.state.rptPaso1TC} 
                      tipo={this.state.rptPaso1TCTipo} 
                      saldoPlan={this.state.rptPaso1TCSaldoPlan} 
                      saldoNormal={this.state.rptPaso1TCSaldoNormal}
                      saldoMora={this.state.rptPaso1TCSaldoMora}
                      diasMora={this.state.rptPaso1TCDiasMora}
                      linea={this.state.rptPaso1TCLinea}/>
                      <Paso3 ref={this.refPaso3} debito={this.state.rptPaso2CuentaDet} importe={this.state.rptPaso2Importe} moneda={this.state.rptPaso2Moneda} tarjeta={this.state.rptPaso1TC} tipo={this.state.rptPaso1TCTipo} deuda={this.state.rptPaso1TCDeuda} paso3Next={this.paso3Next.bind(this)} />
                      <Paso4 ref={this.refPaso4} debito={this.state.rptPaso2CuentaDet} importe={this.state.rptPaso2Importe} moneda={this.state.rptPaso2Moneda} tarjeta={this.state.rptPaso1TC} tipo={this.state.rptPaso1TCTipo} deuda={this.state.rptPaso1TCDeuda}  />
                    </StepWizard>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

    );
  }
}